import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function MaintenancePanel() {
  const [on, setOn] = useState(false);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(true);
  useEffect(() => { api.get("/maintenance").then((r) => { setOn(r.data.on); setMsg(r.data.message); }).finally(() => setBusy(false)); }, []);

  const save = async (next) => {
    setBusy(true);
    try {
      const r = await api.put("/maintenance", { on: next, message: msg });
      setOn(r.data.on);
      setMsg(r.data.message);
      toast.success(r.data.on ? "Maintenance ON — staf tidak bisa login" : "Maintenance OFF — staf bisa login lagi");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="maintenance-panel" className={`rounded-lg border p-4 space-y-3 ${on ? "border-amber-300 bg-amber-50" : "border-slate-200 bg-white"}`}>
      <div className="flex items-center gap-2">
        <Wrench className="h-4 w-4 text-amber-600" />
        <h2 className="font-semibold">Mode maintenance</h2>
        <span data-testid="maintenance-state" className={`ml-auto rounded-full px-3 py-0.5 text-xs font-semibold ${on ? "bg-amber-500 text-white" : "bg-slate-100 text-slate-600"}`}>{on ? "ON" : "OFF"}</span>
      </div>
      <p className="text-sm text-slate-500">Saat ON, semua staf langsung keluar dan tidak bisa login. Hanya admin master yang bisa masuk.</p>
      <label className="text-xs font-semibold text-slate-700">Tulisan untuk staf</label>
      <Input data-testid="maintenance-message-input" disabled={busy} value={msg} onChange={(e) => setMsg(e.target.value)} maxLength={300} className="bg-white" />
      <div className="flex gap-2">
        {on ? (
          <>
            <Button data-testid="maintenance-off-btn" disabled={busy} onClick={() => save(false)} className="bg-emerald-500 hover:bg-emerald-600 text-white">Matikan maintenance</Button>
            <Button data-testid="maintenance-save-msg-btn" variant="outline" disabled={busy} onClick={() => save(true)}>Simpan tulisan</Button>
          </>
        ) : (
          <Button data-testid="maintenance-on-btn" disabled={busy} onClick={() => save(true)} className="bg-amber-500 hover:bg-amber-600 text-white">Nyalakan maintenance</Button>
        )}
      </div>
    </div>
  );
}
